export default "__VITE_ASSET__DgLWlK2W__"